import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { makeAPIRequestReactQueryWithHeaders } from '../api';
import { endpoints } from '../endpoints';

interface FetchHasBenefitsWritebackSupportRequest {
  currentPracticeId: string;
  currentOrganizationId: string;
}

interface GetHasBenefitsWritebackSupportResponse {
  hasBenefitsWritebackSupport: boolean;
}

const fetchHasBenefitsWritebackSupport = async ({
  currentPracticeId,
  currentOrganizationId,
}: FetchHasBenefitsWritebackSupportRequest) => {
  const data =
    await makeAPIRequestReactQueryWithHeaders<GetHasBenefitsWritebackSupportResponse>(
      `/${endpoints.benefitsWritebackSupport}`,
      undefined,
      {
        Practice: currentPracticeId,
        Org: currentOrganizationId,
      },
      'GET',
    );
  return data.hasBenefitsWritebackSupport;
};

export const useHasBenefitsWritebackSupport = () => {
  const {
    primaryPracticeId: currentPracticeId,
    primaryOrganizationId: currentOrganizationId,
  } = useSelector((state: any) => state.login.user);

  return useQuery({
    queryKey: [
      'benefits-writeback-support',
      currentOrganizationId,
      currentPracticeId,
    ],
    queryFn: () => {
      if (!currentPracticeId || !currentOrganizationId) {
        throw new Error('Missing practice or organization ID');
      }
      return fetchHasBenefitsWritebackSupport({
        currentPracticeId,
        currentOrganizationId,
      });
    },
    enabled: !!currentPracticeId && !!currentOrganizationId,
  });
};
